import React, { useState } from "react";
import { CardContent, Card } from "@/shared/ui/card"
import { ProfileWrapper } from '@/shared/components/CardWrapper'
import { 
  AddButton, 
  FindReplaceDesktop, 
  FindReplaceMobile 
} from '@/features/profile/substitutes/Substitutes'
import { useTranslation } from "react-i18next";
import { useGetSubstitutesQuery } from "@/api/rtk/profileApi"

const ProfileSubstitutesTab = ({
  type,
  mode,
  titleKey,
  descriptionKey,
  addButtonKey,
}) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { data } = useGetSubstitutesQuery();
  const substitutes = data?.substitute || [];
  const items = substitutes
    .filter((item) => item && item.type === type)
    .sort((a, b) => {
      const findA = a?.find || "";
      const findB = b?.find || "";
      return findA.localeCompare(findB);
    });
  
  return (
    <ProfileWrapper
      title={t(titleKey)}
      description={t(descriptionKey)}
      hasButton={true}
      buttonContent={
        <AddButton
          label={t(addButtonKey)}
          type={type}
          isOpen={isDialogOpen}
          setIsOpen={setIsDialogOpen}
          className="md:flex hidden" 
          buttonClassName="font-medium"
        />
      }
    >
      <CardContent className="p-0">
        <Card className="w-full rounded-2xl">
          <FindReplaceDesktop 
            items={items} 
            mode={mode} 
          />
          <FindReplaceMobile
            items={items}
            mode={mode}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
          />
        </Card>
      </CardContent>
    </ProfileWrapper>
  );
};

export default ProfileSubstitutesTab;
